"use client";

import React from "react";
import Link from "next/link";
import { 
  ShieldCheck, 
  Scale, 
  Lock, 
  Gavel, 
  FileCheck2, 
  Award,
  ArrowRight
} from "lucide-react";

export default function LegalTrustSection() {
  return (
    <section className="py-16 md:py-24 bg-slate-900 border-b border-slate-800 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* Section Heading */}
        <div className="text-center max-w-3xl mx-auto mb-14 space-y-3">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-slate-800 border border-amber-500/20 text-amber-400 text-xs font-semibold">
            <span>Statutory Credentials & Ethics</span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-serif font-bold text-white tracking-tight">
            Institutional Standing & Privilege Protocols
          </h2>
          <p className="text-xs sm:text-sm text-slate-400 leading-relaxed">
            Operating under rigorous Bar Council ethics, dedicated Advocate-on-Record filings, and zero-knowledge client privilege vaults.
          </p>
        </div>

        {/* 4 Trust Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="p-5 rounded-2xl bg-slate-950 border border-slate-800 space-y-3">
            <div className="w-10 h-10 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 flex items-center justify-center">
              <Scale className="w-5 h-5" />
            </div>
            <h3 className="text-sm font-serif font-bold text-white">
              Supreme Court AOR
            </h3>
            <p className="text-xs text-slate-400 leading-relaxed">
              Designated Advocates-on-Record registered with the Supreme Court of India with certified registry filing authority.
            </p>
          </div>

          <div className="p-5 rounded-2xl bg-slate-950 border border-slate-800 space-y-3">
            <div className="w-10 h-10 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 flex items-center justify-center">
              <Lock className="w-5 h-5" />
            </div>
            <h3 className="text-sm font-serif font-bold text-white">
              Privileged Client Vault
            </h3>
            <p className="text-xs text-slate-400 leading-relaxed">
              Encrypted document repository for draft affidavits, trade secret exhibits, and confidential arbitral transcripts.
            </p>
          </div>

          <div className="p-5 rounded-2xl bg-slate-950 border border-slate-800 space-y-3">
            <div className="w-10 h-10 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 flex items-center justify-center">
              <ShieldCheck className="w-5 h-5" />
            </div>
            <h3 className="text-sm font-serif font-bold text-white">
              Automated Conflict Check
            </h3>
            <p className="text-xs text-slate-400 leading-relaxed">
              Comprehensive internal screening of all incoming matters to prevent adverse representation against ongoing clients.
            </p>
          </div>

          <div className="p-5 rounded-2xl bg-slate-950 border border-slate-800 space-y-3">
            <div className="w-10 h-10 rounded-xl bg-amber-500/10 border border-amber-500/20 text-amber-400 flex items-center justify-center">
              <Gavel className="w-5 h-5" />
            </div>
            <h3 className="text-sm font-serif font-bold text-white">
              eCourts Automated Sync
            </h3>
            <p className="text-xs text-slate-400 leading-relaxed">
              Next Date of Hearing (NDOH) tracking, daily order sheet parsing, and instant WhatsApp hearing dispatch for clients.
            </p>
          </div>
        </div>

        {/* Bottom CTA to View the CRM */}
        <div className="mt-12 p-6 sm:p-8 rounded-2xl bg-gradient-to-r from-amber-500/10 via-slate-850 to-slate-950 border border-amber-500/30 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="space-y-1.5 text-center md:text-left">
            <h4 className="text-base sm:text-lg font-serif font-bold text-white">
              Experience the Full Legal Practice Management Workspace
            </h4>
            <p className="text-xs text-slate-400 max-w-xl">
              Switch from the public law firm website into the dedicated Attorney CRM to explore the 6-stage court pipeline, document vault, and automated client alerts.
            </p>
          </div>

          <Link
            href="/demos/legal/crm"
            className="px-6 py-3.5 rounded-xl bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-slate-950 font-bold text-xs shadow-lg transition-all flex items-center gap-2 shrink-0"
          >
            <span>Launch Attorney CRM Pipeline</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

      </div>
    </section>
  );
}
